export default __webpack_public_path__ + "static/media/cloud-upload.68d39659.svg";